import BaseServer from './BaseServer'

const prod = 'http://watsthemove.herokuapp.com/'
const local = ''

export default class NextServer extends BaseServer { 
	constructor() { 
		super(local, null)
	}
}